import { Injectable } from '@angular/core';
import { SocketMiddlewareService } from './socket-middleware.service';
import { IoEventTypes } from 'icreate/common/io-event/websocket-message';

@Injectable({
    providedIn: 'root',
})
export class ChannelsSocketService {
    constructor(private socketService: SocketMiddlewareService) {}

    onChannelsValueUpdated$() {
        return this.socketService.receiveMessageObserver(IoEventTypes.CHANNELS_VALUES_UPDATED);
    }

    onChannelsUpdated$() {
        return this.socketService.receiveMessageObserver(IoEventTypes.CHANNEL_UPDATED);
    }
}
